import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { NoteView, TabLog, TabsComponent } from "../../../../component/index.jsx"
import { AreaTab } from "./tab/AreaTab.jsx"
import {
  cancelPlatingSeason,
  clearDataDetail,
  clearDataDetailMap,
  confirmationSeasonPlanting,
  getAreaDebt,
  getAreaUnassignList,
  getDetail,
  getListActivity,
  getMapDetail,
  getRejectReasons,
  updateImage,
  updateStatus,
  updateUnassign
} from "../../../../redux/actions/AreaAction.jsx"
import { clearUploadAction } from "../../../../redux/actions/MasterDataAction.jsx"
import { useSubheader } from "../../../../_metronic/layout/index.js"
import { RowModule } from "../../../../component/atoms/RowModule/RowModule.jsx"
import { Button } from "react-bootstrap"
import {
  FlatIconAndText,
  FlatIconAndText2Row
} from "../../../../component/atoms/FlaticonAndText/index.jsx"
import { loadUserLogin } from "../../../service/userManagementAction.js"
import { Popup, PopupQuestion } from "../../../../component/atoms/Popup/index.jsx"
import { FarmerRejectReasons } from "../../../../component/molecule/List/FarmerRejectReasons.jsx"
import swal from "sweetalert"
import { toAbsoluteUrl } from "../../../../_metronic/_helpers/index.js"
import { FarmerUnassignReasons } from "../../../../component/molecule/List/FarmerUnassignReasons.jsx"
import { AREA, ENUM_LOG, WARNING_AREA, GENERAL } from "../../../../constants/InitTypeConstants.js"
import { checkAreaRegisteredValue, stringFormatting, toMeter } from "../../../helpers/TextHelper.js"
import { ButtonDropdown } from "../../../../component/atoms/Button/ButtonDropdown.jsx"
import { ActivityTab } from "./tab/ActivityTab.jsx"
import { ActivityHistoryTab } from "./tab/ActivityHistoryTab.jsx"
import { StatusHistoryTab } from "./tab/StatusHistoryTab.jsx"
import { ICON_CONSTANTS, ILLUSTRATION_CONSTANTS } from "../../../../constants/ImageConstants.js"
import { RoutesConstants } from "../../../../constants/RoutesConstants.js"
import { Skeleton } from "@material-ui/lab"
import { useTranslation } from "react-i18next"
import { PRIVILEGE_ENUM } from "../../../../constants/PrivilegeConstants.js"
import {
  AREA_REGISTERED_ENUM,
  AREA_STATUS_STRING,
  REMOVE_FARMER_REASON_ENUM
} from "../../../../constants/StringConstant.js"
import { GeneralSlice } from "../../../../redux/reducers/General.jsx"

const { actions: general } = GeneralSlice

export const ListAreaDetail = ({
  history,
  match: {
    params: { status, id }
  }
}) => {
  const privileges = loadUserLogin().privilege
  const subHeader = useSubheader()
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const { General, Area, MasterData } = useSelector((state) => state)
  const [detail, setDetail] = useState({})
  const [coordinat, setCoordinat] = useState([])
  const [mapAreas, setMapAreas] = useState([])
  const [agenda] = useState({})
  const [showPopupReject, setShowPopupReject] = useState(false)
  const [showPopupUnassign, setShowPopupUnassign] = useState(false)
  const [rejectReasons, setRejectReasons] = useState([])
  const [showPopupApprove, setShowPopupApprove] = useState(false)

  const [swalMessage, setSwalMessage] = useState("")
  const [swalIcon, setSwallIcon] = useState("")
  const [unassignReasons, setUnassignReasons] = useState(null)
  const [swalRedirect, setSwalRedirect] = useState("")
  const [idDocument, setIdDocument] = useState(null)
  const [popUpMusimTanam, setPopUpMusimTanam] = useState(false)
  const [popUpInfo, setPopUpInfo] = useState(false)
  const [popUpInfoBody, setPopUpInfoBody] = useState("")
  const [isOpenPopupCancelPlantingSeason, setIsOpenPopupCancelPantingSeason] = useState(false)
  const [isOpenPopupConfirmPlantingSeason, setIsOpenPopupConfirmPlantingSeason] = useState(false)
  const [modalAfterCancelPlantingSeason, setModalAfterCancelPlantingSeason] = useState(false)
  const [otherReasonText, setOtherReasonText] = useState()
  const [loadingMap, setLoadingMap] = useState(true)

  const [selectedTab, setSelectedTab] = useState(0)

  const onChangeTab = (index) => {
    setSelectedTab(index)
  }

  useEffect(() => {
    dispatch(
      general.setLoading({
        loading: false,
        actionInitType: null
      })
    )
  }, [])

  useEffect(() => {
    if (detail) {
      subHeader.setBreadcrumbs([
        {
          pathname: RoutesConstants.AREA.LIST_AREA_TEREGISTRASI(AREA_REGISTERED_ENUM.MT_ACTIVE),
          title: t("label_area_name")
        },
        {
          pathname:
            checkAreaRegisteredValue(status)
              ? RoutesConstants.AREA.LIST_AREA_TEREGISTRASI(status)
              : RoutesConstants.AREA.LIST_AREA_STATUS(status),
          title: checkAreaRegisteredValue(status)
            ? t("label_registered")
            : status
        },
        {
          title: detail.name
        }
      ])
    }
  }, [detail])

  useEffect(() => {
    if (General.isFinishUpdateOrDelete) {
      if (General.actionInitType === AREA.UPDATE_STATUS) {
        swal({
          text: t("messages_response_success_approve_area"),
          icon: toAbsoluteUrl(ILLUSTRATION_CONSTANTS.AREA_SUCCESS),
          buttons: {
            detail: {
              text: t("button_see_detail"),
              className: "sweet-outline-success"
            },
            okey: { text: "Ok", className: "sweet-success" }
          }
        }).then((value) => {
          switch (value) {
            case "detail":
              history.push(swalRedirect)
              break
            default:
              true
          }
        })
        history.push(RoutesConstants.AREA.LIST_PENDING())
      } else if (General.actionInitType === AREA.UPDATE_STATUS_FARMER) {
        swal({
          text: swalMessage,
          icon: toAbsoluteUrl(swalIcon)
        })
        history.push(
          RoutesConstants.AREA.LIST_AREA_TEREGISTRASI(AREA_REGISTERED_ENUM.MT_ACTIVE)
        )
      } else if (General.actionInitType === GENERAL.UPLOAD) {
        const indexIdDocument = idDocument ?? 0
        const data = {
          area_document_id: detail?.link_document_area[indexIdDocument]?.id,
          url: MasterData.urlResponseUpload
        }

        dispatch(updateImage({ id, data }))
      } else if (General.actionInitType === AREA.UPDATE_IMAGE) {
        dispatch(getDetail(id))
        dispatch(getMapDetail(id))
      } else if (General.actionInitType === AREA.PLANTING_SEASON_CONFIRMATION) {
        swal({
          text: t("messages_response_success_confirm_planting_season"),
          icon: toAbsoluteUrl(ILLUSTRATION_CONSTANTS.SUCCESS_PLANTING_SEASON_CONFIRMATION)
        }).then(() => {
          dispatch(getDetail(id))
          dispatch(getMapDetail(id))
        })
      } else if (General.actionInitType === AREA.CANCEL_PLANTING_SEASON) {
        setModalAfterCancelPlantingSeason(true)
      }
    }
  }, [General])

  const removeAssign = () => {
    if (detail?.is_hst) {
      setPopUpInfo(true)
      setPopUpInfoBody(t("messages_alert_failed_remove_assign_farmer_planting_activity"))
    } else {
      setSwalMessage(t("messages_response_success_remove_assign_farmer"))
      setSwallIcon(toAbsoluteUrl(ILLUSTRATION_CONSTANTS.AREA_SUCCESS))
      setShowPopupUnassign(true)
    }
  }
  const konfirmasiMusimTanam = () => {
    if (detail?.is_harvest) {
      setPopUpMusimTanam(true)
    } else {
      setPopUpInfo(true)
      setPopUpInfoBody(t("messages_confirmation_cant_confirm_planting_season_plant_activity"))
    }
  }

  const [btnDropdownList, setBtnDropdown] = useState([])

  useEffect(() => {
    const dropdonwList = []
    if (detail?.farmer_response?.id) {
      dropdonwList.push({
        title: t("dropdown_remove_farmer"),
        icon: ICON_CONSTANTS.ACTION.FARMER,
        action: removeAssign,
        showed: true
      })
    }

    if (
      status === AREA_REGISTERED_ENUM.MT_ACTIVE &&
      detail?.has_allowed_confirm_planting_season &&
      !detail?.requires_ba_confirmation
    ) {
      dropdonwList.push({
        title: t("dropdown_confirm_the_planting_season"),
        icon: ICON_CONSTANTS.ACTION.HARVEST,
        action: konfirmasiMusimTanam,
        showed: privileges.indexOf(PRIVILEGE_ENUM.HARVEST_CONFIRMATION) > -1
      })
    }
    if (
      status === AREA_REGISTERED_ENUM.MT_ACTIVE &&
      detail?.has_allowed_confirm_planting_season &&
      detail?.requires_ba_confirmation
    ) {
      dropdonwList.push({
        title: t("dropdown_confirm_planting_season"),
        icon: ICON_CONSTANTS.ACTION.HARVEST,
        action: openModalConfirmPlantingSeason,
        showed: privileges.indexOf(PRIVILEGE_ENUM.HARVEST_CONFIRMATION) > -1
      })
    }
    if (status === AREA_REGISTERED_ENUM.MT_ACTIVE && detail?.has_allowed_cancel_planting_season) {
      dropdonwList.push({
        title: t("dropdown_cancel_planting_season"),
        icon: ICON_CONSTANTS.ACTION.SUSPEND,
        action: openModalCancelPlantingSeason,
        showed: privileges.indexOf(PRIVILEGE_ENUM.HARVEST_CONFIRMATION) > -1
      })
    }
    if (status === AREA_REGISTERED_ENUM.MT_ACTIVE && detail?.has_allowed_failed_harvest) {
      dropdonwList.push({
        title: "Gagal Panen",
        icon: ICON_CONSTANTS.ACTION.BULLET_CLOSE_OUTLINE,
        action: failedHarvest,
        showed: privileges.indexOf(PRIVILEGE_ENUM.HARVEST_CONFIRMATION) > -1
      })
    }

    setBtnDropdown(dropdonwList)
  }, [status, detail])

  function failedHarvest() {
    history.push(RoutesConstants.AREA.FORM_FAILED_HARVEST(id))
  }

  function openModalCancelPlantingSeason() {
    setIsOpenPopupCancelPantingSeason(true)
  }

  function openModalConfirmPlantingSeason() {
    setIsOpenPopupConfirmPlantingSeason(true)
  }

  useEffect(() => {
    switch (status) {
      case AREA_REGISTERED_ENUM.MT_ACTIVE:
      case AREA_REGISTERED_ENUM.MT_COMPLETED:
      case AREA_REGISTERED_ENUM.LAND_NEW:
        subHeader.setButton(<ButtonDropdown title={"Action"} dropdownList={btnDropdownList} />)
        break
      case AREA_STATUS_STRING.REJECT:
        subHeader.setButton(null)
        break

      case AREA_STATUS_STRING.PENDING:
        if (privileges.indexOf(PRIVILEGE_ENUM.APPROVAL_AREA_REGISTRATION) > -1) {
          subHeader.setButton(
            <RowModule>
              <>
                <Button
                  variant="danger"
                  onClick={() => {
                    setShowPopupReject(true)
                    setSwalMessage(t("messages_response_success_reject_area"))
                    setSwallIcon(toAbsoluteUrl(ILLUSTRATION_CONSTANTS.AREA_REJECT))
                    setSwalRedirect(RoutesConstants.AREA.DETAIL_AREA(AREA_STATUS_STRING.REJECT, id))
                  }}>
                  Reject
                </Button>
                <Button
                  variant="primary"
                  className="ml-2"
                  onClick={() => {
                    setShowPopupApprove(true)
                    setSwalRedirect(RoutesConstants.AREA.DETAIL_AREA(AREA_REGISTERED_ENUM.MT_ACTIVE, id))
                    setSwalMessage(t("messages_response_success_verify_area"))
                    setSwallIcon(toAbsoluteUrl(ILLUSTRATION_CONSTANTS.AREA_SUCCESS))
                  }}>
                  Approve
                </Button>
              </>
            </RowModule>
          )
        }
        break
      case AREA_STATUS_STRING.LEAD:
        subHeader.setButton(
          <Button
            variant="danger"
            onClick={() => {
              history.push(RoutesConstants.AREA.EDIT_AREA(id))
            }}>
            Delete
          </Button>
        )
        break

      default:
        break
    }
  }, [status, detail, btnDropdownList])

  useEffect(() => {
    if (detail && !detail.is_hast) {
      dispatch(getAreaUnassignList())
    }
  }, [dispatch, detail?.is_hast])

  useEffect(() => {
    if (status === AREA_STATUS_STRING.PENDING) {
      dispatch(getRejectReasons())
    }
  }, [status])

  useEffect(() => {
    dispatch(getDetail(id))
    dispatch(getAreaDebt(id))
    dispatch(getMapDetail(id))
    dispatch(clearUploadAction())

    return () => {
      dispatch(clearDataDetail())
      dispatch(clearDataDetailMap())
    }
  }, [])

  useEffect(() => {
    if (Area.data) {
      setDetail(Area.data)
    }
  }, [Area.data])

  useEffect(() => {
    if (detail.coordinate) {
      setCoordinat(
        detail.coordinate.map((item) => {
          return {
            lat: item.latitude,
            lng: item.longitude
          }
        })
      )
    }
  }, [detail.coordinate])

  useEffect(() => {
    if (Area.mapDetail) {
      setLoadingMap(false)
      setMapAreas(Area.mapDetail)
    }
  }, [Area.mapDetail])

  const landArea = (data, category) => {
    return (
      <div>
        {toMeter(stringFormatting(data))} ({category})
      </div>
    )
  }

  const descriptionLeft = (data) => {
    return (
      <>
        <div className="d-flex flex-wrap mb-4">
          <FlatIconAndText
            text={landArea(data?.land_area, "Manual")}
            svg={ICON_CONSTANTS.FIELD_2}
          />
          <FlatIconAndText
            text={landArea(data?.estimated_land_area, "Polygon")}
            svg={ICON_CONSTANTS.FIELD_2}
          />
          <FlatIconAndText text={data?.soil_type ?? "-"} svg={ICON_CONSTANTS.SOIL_ALT} />
          <FlatIconAndText text={data?.soil_dept ?? "-"} svg={ICON_CONSTANTS.SOIL} />
          <FlatIconAndText text={data?.irrigation ?? "-"} svg={ICON_CONSTANTS.WATER_IRRIGATION} />
        </div>
        {General.loading ? (
          <>
            <Skeleton animation="wave" variant={"text"} width={250} />
            <Skeleton animation="wave" variant={"text"} width={200} />
          </>
        ) : (
          <>
            <span className="font-weight-bold text-dark-50">
              {data?.sub_district_name + " - " + data?.district_name}
            </span>
            <span className="font-weight-bold text-dark-50">
              {data?.regency_name + " - " + data?.province_name}
            </span>
            <NoteView
              icon={
                data?.potential_issue?.toUpperCase() === WARNING_AREA.TIDAK_ADA
                  ? ICON_CONSTANTS.INFO
                  : ICON_CONSTANTS.WARNING
              }
              variant={
                data?.potential_issue?.toUpperCase() === WARNING_AREA.TIDAK_ADA ? "info" : "warning"
              }
              className={"w-fit"}
              title={
                <div className={"d-flex align-items-center"}>
                  {t("messages_title_land_hazard_potential")} : <br />
                  <div className={"font-weight-bolder ml-2"}>{data?.potential_issue}</div>
                </div>
              }
            />
          </>
        )}
      </>
    )
  }

  const flatIconAndText2Rows = (data) => {
    return (
      <>
        <FlatIconAndText2Row
          rounded={true}
          title={t("label_farmer_name")}
          description={data?.farmer_response?.name}
          svg={ICON_CONSTANTS.FARMER_BIG}
          status={status}
          is_hst={data?.is_hst}
        />
        <FlatIconAndText2Row
          rounded={true}
          title={t("label_ownership")}
          description={data?.land_ownership ?? "-"}
          svg={ICON_CONSTANTS.DOCUMENT}
        />
        <FlatIconAndText2Row
          rounded={true}
          title={t("label_mitra_name")}
          description={data?.mitra_profile_response?.name}
          svg={ICON_CONSTANTS.MITRA_2}
        />
        <FlatIconAndText2Row
          rounded={true}
          title={t("label_planting_season_completed")}
          description={data?.planting_season_finish_count + " Musim Panen"}
          svg={ICON_CONSTANTS.HARVEST}
        />
        {data?.total_failed_harvest > 0 && (
          <FlatIconAndText2Row
            rounded={true}
            title={t("label_failed_harvest")}
            description={data?.total_failed_harvest + " Kali"}
            svg={ICON_CONSTANTS.FAILUR_HARVEST}
          />
        )}
      </>
    )
  }

  const getTabContents = () => {
    const labelList = [t("label_area_detail").toUpperCase()]
    const componentList = [
      <AreaTab
        key={0}
        detail={detail}
        titleCardDetail={detail.name}
        descriptionLeft={descriptionLeft(detail)}
        flatIconAndText2Rows={flatIconAndText2Rows(detail, agenda)}
        documentLahan={detail.link_document_area}
        coordinate={coordinat}
        zoom={15}
        rejectReason={detail?.reason_rejection}
        setIdDocument={setIdDocument}
        mapAreas={mapAreas}
        loadingMap={loadingMap}
        status={status}
        setSelectedTab={setSelectedTab}
      />
    ]

    if (checkAreaRegisteredValue(status)) {
      if (privileges.indexOf(PRIVILEGE_ENUM.TAB_ACTIVITY) > -1) {
        labelList.push(t("label_activity").toUpperCase())
        componentList.push(<ActivityTab id={id} status={status} history={history} />)
      }

      if (privileges.indexOf(PRIVILEGE_ENUM.TAB_ACTIVITY_HISTORY) > -1) {
        labelList.push(t("label_activity_history").toUpperCase())
        componentList.push(<ActivityHistoryTab id={id} history={history} status={status} />)
      }

      labelList.push(t("label_status_history").toUpperCase())
      componentList.push(<StatusHistoryTab id={id} />)
    }

    if (status) {
      labelList.push(t("label_log").toUpperCase())
      componentList.push(<TabLog historyTabEnum={ENUM_LOG.AREA} id={id} />)
    }

    return {
      labels: labelList,
      contents: componentList
    }
  }

  const areaUpdateStatus = async (status = "") => {
    dispatch(updateStatus(id, status.toUpperCase(), rejectReasons))
  }

  const areaUpdateUnassign = async () => {
    dispatch(updateUnassign(id, unassignReasons, otherReasonText))
  }

  const modulPopUpMusimTanam = (
    <PopupQuestion
      show={popUpMusimTanam}
      title={t("messages_title_planting_season_confirmation")}
      isUseFooter={false}
      bodyCustom={
        <>
          <div className="text-center py-6">
            <span>{t("messages_confirmation_planting_season_confirmation_question")} </span>
            <br />
            <span>Informasi aktivitas akan dipindahkan ke tab </span>
            <span className="font-weight-bold">Riwayat Aktivitas.</span>
          </div>
          <div
            className="w-100 d-flex pt-12"
            style={{ gap: 12 }}
            onClick={() => setPopUpMusimTanam(false)}>
            <Button variant="secondary-info" color="muted" className="w-100">
              {t("button_cancel")}
            </Button>
            <Button
              className="w-100"
              onClick={() => {
                dispatch(confirmationSeasonPlanting(id))
                setPopUpMusimTanam(false)
              }}>
              {t("button_next")}
            </Button>
          </div>
        </>
      }
    />
  )

  const modulPopUpInfo = (
    <Popup
      show={popUpInfo}
      body={popUpInfoBody}
      textOk="Ok"
      onClick={() => {
        setPopUpInfo(false)
      }}
      type={"gagal"}
    />
  )

  function PopupCancelPlantingSeasonBody() {
    return (
      <div className={"text-center"}>
        Dengan membatalkan musim tanam, status tanam lahan yang terdaftar akan menjadi{" "}
        <strong>Inactive.</strong> Pastikan lahan yang dipilih telah benar.
      </div>
    )
  }

  function bodyAfterCancelPlantingSeason() {
    return (
      <div className={"text-center d-flex align-items-center flex-column"}>
        <img
          style={{ width: 160 }}
          src={
            General.actionInitType === AREA.CANCEL_PLANTING_SEASON && General.isError
              ? ILLUSTRATION_CONSTANTS.FAIL
              : ILLUSTRATION_CONSTANTS.SUCCESS_FAILED_HARVEST
          }
        />
        {General.actionInitType === AREA.CANCEL_PLANTING_SEASON && General.isError ? (
          <div className={"mt-4"}>
            Lahan tidak dapat dinyatakan <strong>Batal Musim Tanam</strong> karena lahan masih
            memiliki kegiatan bersama Maxxitani. Mohon diperiksa kembali.
          </div>
        ) : (
          <div className={"mt-4"}>Lahan berhasil dinyatakan batal musim tanam.</div>
        )}
      </div>
    )
  }

  const modulPopUpRemoveFarmer = (
    <PopupQuestion
      show={showPopupUnassign}
      title={t("messages_title_remove_farmer_from_area")}
      bodyCustom={
        <FarmerUnassignReasons
          items={Area?.unassignFarmerReasons}
          name={"farmerUnassign"}
          onChange={(value) => {
            setUnassignReasons(value.enum_name)
            setOtherReasonText(value.reason)
          }}
        />
      }
      textOk="Submit"
      onCancel={() => {
        setShowPopupUnassign(false)
        setUnassignReasons(null)
        setOtherReasonText(null)
      }}
      disable={(unassignReasons && unassignReasons.length > 0) ? !(unassignReasons === REMOVE_FARMER_REASON_ENUM.OTHER ? otherReasonText && otherReasonText.length > 0 : true) : true}
      onOk={() => {
        areaUpdateUnassign()
        setShowPopupUnassign(false)
      }}
    />
  )

  const modulPopUpReject = (
    <PopupQuestion
      show={showPopupReject}
      title={t("messages_title_land_does_not_meet_the_criteria")}
      bodyCustom={
        <FarmerRejectReasons
          items={Area?.rejectReasons}
          onChange={(list) => {
            setRejectReasons(list)
          }}
        />
      }
      textOk="Reject"
      onCancel={() => {
        setShowPopupReject(false)
        setRejectReasons([])
      }}
      disable={rejectReasons.length > 0 ? false : true}
      onOk={() => {
        areaUpdateStatus("REJECTED")
        setShowPopupReject(false)
      }}
    />
  )

  const modulPopUpApprove = (
    <PopupQuestion
      show={showPopupApprove}
      title={t("messages_title_land_does_meet_the_criteria")}
      bodyCustom={
        <span>
          Data Lahan yang disetujui akan berubah menjadi{" "}
          <span className="font-weight-bold">terverifikasi</span>. Pastikan semua data telah lengkap
          dan benar.
        </span>
      }
      textOk="Approve"
      onCancel={() => {
        setShowPopupApprove(false)
      }}
      onOk={() => {
        areaUpdateStatus("ACTIVE")
        setShowPopupApprove(false)
        setShowPopup({
          show: true,
          body: "Petani berhasil diverifikasi"
        })
      }}
    />
  )

  const modulPopupConfirmPlantingSeason = (
    <PopupQuestion
      show={isOpenPopupConfirmPlantingSeason}
      bodyCustom={
        <>
          <div className={"text-center py-4 px-8"}>
            Konfirmasi Musim Tanam yang memiliki tagihan mengharuskan Upload{" "}
            <strong>Berita Acara</strong> sebagai langkah selanjutnya.
            <br />
            <br />
            Informasi aktivitas akan dipindahkan ke tab <strong>Riwayat Aktivitas</strong>.
          </div>
          <div
            className="w-100 d-flex pt-12"
            style={{ gap: 12 }}
            onClick={() => setIsOpenPopupConfirmPlantingSeason(false)}>
            <Button variant="secondary-info" color="muted" className="w-100">
              {t("button_cancel")}
            </Button>
            <Button
              className="w-100"
              onClick={() => {
                history.push(RoutesConstants.AREA.SEND_PLANTING_SESSION_REPORT(id))
                setIsOpenPopupConfirmPlantingSeason(false)
              }}>
              {t("button_next")}
            </Button>
          </div>
        </>
      }
      isUseFooter={false}
      textOk={t("button_next")}
      onCancel={() => setIsOpenPopupConfirmPlantingSeason(false)}
      title={t("messages_title_planting_season_confirmation")}
    />
  )

  return (
    <>
      {modulPopUpMusimTanam}
      {modulPopUpInfo}
      {modulPopUpRemoveFarmer}
      {modulPopUpReject}
      {modulPopUpApprove}
      {modulPopupConfirmPlantingSeason}
      <PopupQuestion
        show={isOpenPopupCancelPlantingSeason}
        bodyCustom={PopupCancelPlantingSeasonBody()}
        textOk="Lanjut"
        textCancel={"Batal"}
        onCancel={() => setIsOpenPopupCancelPantingSeason(false)}
        closeButton={true}
        title={"BATAL MUSIM TANAM"}
        onOk={() => {
          dispatch(cancelPlatingSeason(id))
          setIsOpenPopupCancelPantingSeason(false)
        }}
      />
      <Popup
        show={modalAfterCancelPlantingSeason}
        bodyCustom={bodyAfterCancelPlantingSeason()}
        textOk="Ok"
        variantCancelButton={"outline-primary"}
        onClick={() => {
          setModalAfterCancelPlantingSeason(false)
          setTimeout(() => {
            dispatch(getDetail(id))
            dispatch(getMapDetail(id))
            dispatch(getListActivity(id))
          }, 200)
        }}
      />
      <TabsComponent
        key={selectedTab}
        labelTab={getTabContents().labels}
        componentTab={getTabContents().contents}
        initValue={selectedTab}
        changeTab={onChangeTab}
      />
    </>
  )
}
